export const blue = 'css;font-weight:normal!important;color:#2185D0';
export const green = 'css;font-weight:normal!important;color:green';
export const darkgreen = 'css;font-weight:normal!important;color:#006400';
export const grey = 'css;font-weight:normal!important;color:grey';
export const darkgrey = 'css;font-weight:normal!important;color:#444';
export const red = 'css;font-weight:normal!important;color:red';
export const brown = 'css;font-weight:normal!important;color:brown';
export const orange = 'css;font-weight:normal!important;color:orange';
export const violet = 'css;font-weight:normal!important;color:violet';
export const purple = 'css;font-weight:normal!important;color:purple';
export const chocolate = 'css;font-weight:normal!important;color:chocolate';
export const marsala = 'css;font-weight:normal!important;color:#955251';
export const header = 'css;color: #FF0000; font-size: 40px; font-weight:bold; font-family:verdana; text-shadow:1px 1px 1px black;';
export const bigText = 'css;color: #000000; font-size: 20px; font-family:verdana;';
